// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import ArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import ArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import cx from 'classnames'
import moment from 'moment'
import React from 'react'
import { withRouter } from 'react-router-dom'
import type { WithDateProps } from '../../common/date/withDate'
import DateField from '../dateField/DateField'
import MonthField from '../monthField/MonthField'
import WeekField from '../weekField/WeekField'
import css from './dateBar.css'

type DateBarProps = WithDateProps & {
  dateUnit: 'day' | 'week' | 'month'
  className?: string
  modifiers?: any
  showRightArrow?: boolean
  showLeftArrow?: boolean
}

class DateBar extends React.Component<DateBarProps> {
  static defaultProps = {
    dateFormat: 'YYYY-MM-DD',
    dateUnit: 'day',
    modifiers: {},
    showRightArrow: true,
    showLeftArrow: true,
  }
  changeDay = (date) => {
    const { onDateChange, scrollToBottom } = this.props
    onDateChange(date)

    if (scrollToBottom) {
      this.scrollToPosition(window.scrollY)
    }
  }
  getNextDate = () => moment(this.props.date).add(1, this.props.dateUnit).format(this.props.dateFormat)
  getPrevDate = () => moment(this.props.date).add(-1, this.props.dateUnit).format(this.props.dateFormat)
  scrollToPosition = (position) => {
    setTimeout(() => {
      window.scrollTo({
        left: 0,
        top: position,
        behavior: 'smooth',
      })
    }, 500)
  }

  render() {
    const { dateUnit, date, className, modifiers, showRightArrow, showLeftArrow } = this.props
    let FieldComponent

    switch (dateUnit) {
      case 'week':
        FieldComponent = WeekField
        break

      case 'month':
        FieldComponent = MonthField
        break

      default:
        FieldComponent = DateField
    }

    return (
      <div className={cx(css.component, className)}>
        <a
          data-testid='date-bar-prev-date-button'
          className={
            showLeftArrow ? cx(css.navLink, css.navLinkPrev) : cx(css.navLink, css.navLinkPrev, css.navLinkDisabled)
          }
          onClick={() => this.changeDay(this.getPrevDate())}
        >
          <ArrowLeftIcon />
        </a>
        <FieldComponent value={date} onChange={this.changeDay} modifiers={modifiers} />
        <a
          data-testid='date-bar-next-date-button'
          className={
            showRightArrow ? cx(css.navLink, css.navLinkNext) : cx(css.navLink, css.navLinkNext, css.navLinkDisabled)
          }
          onClick={() => this.changeDay(this.getNextDate())}
        >
          <ArrowRightIcon />
        </a>
      </div>
    )
  }
}

export default withRouter<DateBarProps>(DateBar)
